import { useNavigate } from "react-router-dom";

import { isClient } from "@/lib/common";
import type { IInformationModal } from "@/src/common/InformationModal";
import { InformationModal } from "@/src/common/InformationModal";
import { CashbackDetails } from "@Routes/CashbackLinks";

const useConfirmModal = (confirmModal: IInformationModal, skipClean?: boolean) => {
    const navigate = useNavigate();
    const cleanUrl = () => {
        if (skipClean) {
            return;
        }

        navigate(CashbackDetails, { replace: true });
    };

    return isClient && confirmModal && <InformationModal {...confirmModal} onClose={cleanUrl} />;
};

export default useConfirmModal;
